module.exports = __webpack_public_path__ + "media/mypage/images/service/service3-e1c33ff3764ce20af627838aa5f58568.jpg";